import React from 'react';
import {Link} from "react-router-dom";

const CourseTypeOne = ({ data, isSubscribed, classes, image_location_path='01' }) => {



    return (
        <div className={`edu-course course-style-1 ${ classes ? classes : '' } hover-button-bg-white`}>
            <div className="inner">
                <div className="thumbnail" style={{maxWidth: "260px"}}>
                    <Link to={`/course/${data.id}`}>
                        <a>
                            {data.image240x135 ?
                                <img className="image" src={data.image240x135} alt="course-image" /> :
                                <img className="image" src="/assets/images/placeholderImage.jpg" alt="course-image"/>
                            }
                        </a>
                    </Link>
                    <div className="time-top">
                        <span className="duration"><i className="icon-61"></i>{data.duration}</span>
                    </div>
                </div>
                <div className="content">
                    <span className="course-level">{data.instructionalLevel}</span>
                    <h6 className="title">
                        <Link to={`/course/${data.id}`}>
                            <a>{data.title}</a>
                        </Link>
                    </h6>
                    {/*<div className="course-rating">*/}
                    {/*    <div className="rating">*/}
                    {/*        <i className="icon-23"></i>*/}
                    {/*        <i className="icon-23"></i>*/}
                    {/*        <i className="icon-23"></i>*/}
                    {/*        <i className="icon-23"></i>*/}
                    {/*        <i className="icon-23"></i>*/}
                    {/*    </div>*/}
                    {/*    <span className="rating-count">({data.rating} /{data.rating_count} Rating)</span>*/}
                    {/*</div>*/}
                    {/*<div className="course-price">${data.course_price}</div>*/}
                    <ul className="course-meta">
                        <li><i className="icon-24"></i>{data.numOfPublishedLectures} Ders</li>
                        <li><i className="icon-61"></i>{data.contentInfo}</li>
                        {/*<li>{data.instructionalLevel}</li>*/}
                    </ul>
                    {isSubscribed &&
                        <>
                            {/*<ProgressBar value={50}/> <p>{20}% tamamlandı</p>*/}

                            {/*<Button severity="secondary" className="button-course-card" onClick={console.log("test")}>*/}
                            {/*    <img src={dotsIcon}></img>*/}
                            {/*</Button>*/}
                            <div className="read-more-btn">
                                <a href={`/course/view/${data.id}`} className="edu-btn btn-small">Kursa Devam Et <i className="icon-4"></i></a>
                            </div>
                        </>}
                </div>
            </div>

            {/*<div className="course-hover-content-wrapper">*/}
            {/*    <button onClick={() => {*/}
            {/*    }} className={`wishlist-btn}`}><i className="icon-22"></i></button>*/}
            {/*</div>*/}

            {/*<div className="course-hover-content">*/}
            {/*    <div className="content">*/}
            {/*        <button onClick={() => {}} className={`wishlist-btn}`}>*/}
            {/*            <i className="icon-22"></i>*/}
            {/*        </button>*/}
            {/*        <span className="course-level">{data.level}</span>*/}
            {/*            <h6 className="title">*/}
            {/*                <Link to={`/course-details/${data.id}`}>*/}
            {/*                    <a>{data.title}</a>*/}
            {/*                </Link>*/}
            {/*            </h6>*/}
            {/*        <div className="course-rating">*/}
            {/*            <div className="rating">*/}
            {/*                <i className="icon-23"></i>*/}
            {/*                <i className="icon-23"></i>*/}
            {/*                <i className="icon-23"></i>*/}
            {/*                <i className="icon-23"></i>*/}
            {/*                <i className="icon-23"></i>*/}
            {/*            </div>*/}
            {/*            <span className="rating-count">({data.rating} /{data.rating_count} Rating)</span>*/}
            {/*        </div>*/}
            {/*        <div className="course-price">${data.course_price}</div>*/}
            {/*        <p>{data.short_desc}</p>*/}
            {/*        <ul className="course-meta">*/}
            {/*            <li><i className="icon-24"></i>{data.lesson} Lessons</li>*/}
            {/*            <li><i className="icon-25"></i>{data.student} Students</li>*/}
            {/*        </ul>*/}
            {/*        <a onClick={() => {}} className="edu-btn btn-secondary btn-small" style={{ cursor: 'pointer' }}>*/}
            {/*            {false ? 'Added to cart' : 'Add to cart'}*/}
            {/*            <i className="icon-4"></i>*/}
            {/*        </a>*/}
            {/*    </div>*/}
            {/*</div>*/}
        </div>
    )
}

export default CourseTypeOne;